enum RegistrationFieldBindings {
  Team = 'team',
};

export default RegistrationFieldBindings;
